function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.019 15c0 6.065 4.916 10.98 10.981 10.98 6.065 0 10.98-4.915 10.98-10.98S21.066 4.019 15 4.019",
  stroke: "#fff",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.51 9.51c-3.032-5.253-9.748-7.052-15-4.02-5.252 3.033-7.052 9.748-4.02 15 3.033 5.253 9.749 7.052 15 4.02",
  stroke: "#fff",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 13.062,
  r: 3.876,
  stroke: "#fff",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.752 22.751c0-2.497-3.828-5.167-7.752-5.167S7.25 20.254 7.25 22.75",
  stroke: "#fff",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var SvgPlaceForYou = function SvgPlaceForYou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMDE5MDQgMTVDNC4wMTkwNCAyMS4wNjQ2IDguOTM1MzcgMjUuOTgwOSAxNSAyNS45ODA5QzIxLjA2NDYgMjUuOTgwOSAyNS45ODA5IDIxLjA2NDYgMjUuOTgwOSAxNUMyNS45ODA5IDguOTM1MzcgMjEuMDY0NiA0LjAxOTA0IDE1IDQuMDE5MDQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik0yNC41MSA5LjUwOTUzQzIxLjQ3NzcgNC4yNTc0MyAxNC43NjE5IDIuNDU3OTMgOS41MDk4IDUuNDkwMjNDNC4yNTc3MSA4LjUyMjUzIDIuNDU4MjEgMTUuMjM4NCA1LjQ5MDUxIDIwLjQ5MDVDOC41MjI4MSAyNS43NDI1IDE1LjIzODYgMjcuNTQyIDIwLjQ5MDcgMjQuNTA5NyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPGNpcmNsZSBjeD0iMTUuMDAwMSIgY3k9IjEzLjA2MjEiIHI9IjMuODc1NjIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik0yMi43NTE1IDIyLjc1MTJDMjIuNzUxNSAyMC4yNTQgMTguOTI0NCAxNy41ODM3IDE1LjAwMDMgMTcuNTgzN0MxMS4wNzYxIDE3LjU4MzcgNy4yNDkwMiAyMC4yNTQgNy4yNDkwMiAyMi43NTEyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8L3N2Zz4K";
export { SvgPlaceForYou as ReactComponent };